import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

import DefaultLayout from '@/components/Layout/Layout';
import Home from '@/pages/Home/Home';
import Introduce from '@/pages/Introduce/Introduce';
import Information from '@/pages/Information/Information';
import InfoPlace from '@/pages/InfoPlace/InfoPlace';
import Conference from '@/pages/Conference/Conference';
import ConferenceDetail from '@/pages/ConferenceDetail/ConferenceDetail';
import InfoPlaceDetail from '@/pages/InfoPlaceDetail/InfoPlaceDetail';
import Membership from '@/pages/Membership/Membership'; // 오타 수정
import Auth from '@/pages/Auth/Auth';
import FindPw from '@/pages/FindPw/FindPw';
import FindId from '@/pages/FindId/FindId';
import SignUp from '@/pages/SignUp/SignUp';
import MyPage from '@/pages/MyPage/MyPage';
import ModifyPw from '@/pages/ModifyPw/ModifyPw';
import CompleteFindId from '@/pages/CompleteFindId/CompleteFindId';
const router = createBrowserRouter([
	{
		element: <DefaultLayout />,
		children: [
			{ path: '/', element: <Home /> },
			{ path: '/home', element: <Navigate to="/" replace /> },
			{ path: '/index.html', element: <Navigate to="/" replace /> },
			{ path: '/auth/login', element: <Auth /> },
			{ path: '/auth/findid', element: <FindId /> },
			{ path: '/auth/findid/complete', element: <CompleteFindId /> },
			{ path: '/auth/findpw', element: <FindPw /> },
			{ path: '/auth/findpw/modify', element: <ModifyPw /> },
			{ path: '/auth/signup', element: <SignUp /> },
			{ path: '/mypage', element: <MyPage /> },
			{ path: '/introduce', element: <Introduce /> },
			{ path: '/membership', element: <Membership /> }, // 오타 수정
			{ path: '/information', element: <Information /> },
			{ path: '/conference', element: <Conference /> },
			{ path: '/conference/detail/:id', element: <ConferenceDetail /> },
			{ path: '/infoplace', element: <InfoPlace /> },
			{ path: '/infoplace/detail/:id', element: <InfoPlaceDetail /> },
		],
	},
]);

const Router = () => (
	<RouterProvider
		router={router}
		future={{
			v7_startTransition: true,
		}}
	/>
);

export default Router;
